const warehouses = {//Monterrey 3637
    // "Monterrey - 3637": [
    //     64030, 
    //     64040, 
    //     64049, 
    //     64050, 
    //     64630, 
    //     64634, 
    //     64635, 
    //     64637, 
    //     64639, 
    //     64640, 
    //     64649, 
    //     64650, 
    //     64659, 
    //     64660, 
    //     64710, 
    //     64715, 
    //     64718, 
    //     64720, 
    //     66200, 
    //     66224, 
    //     66226, 
    //     66230, 
    //     66235, 
    //     66236, 
    //     66237, 
    //     66240, 
    //     66244, 
    //     66247, 
    //     66249, 
    //     66250, 
    //     66254, 
    //     66256, 
    //     66257, 
    //     66259, 
    //     66263, 
    //     66264, 
    //     66265, 
    //     66266, 
    //     66267, 
    //     66268, 
    //     66269, 
    //     66270, 
    //     66273, 
    //     66274, 
    //     66275, 
    //     66276, 
    //     66277, 
    //     66278, 
    //     66279, 
    //     66280, 
    //     66285, 
    //     66286, 
    //     66287, 
    //     66290, 
    //     66295, 
    //     66296, 
    //     66297
    // ], // Culiacan
    "Tienda en línea Culiacán - 4106": [
        80000,
        80010,
        80013,
        80014,
        80015,
        80016,
        80017,
        80018,
        80019,
        80020,//Quitar
        80024,
        80025,
        80026,
        80027,
        80028,
        80029,
        80030,//Quitar
        80034,
        80040,//Quitar
        80050,
        80054,
        80055,
        80058,
        80059,
        80060,//Quitar
        80063,
        80064,
        80065,//Quitar
        80070,//Quitar
        80080,
        80088,
        80090,//Quitar
        80093,
        80100,
        80101,
        80103,
        80104,
        80105,
        80106,
        80107,
        80109,
        80110,
        80120,
        80128,
        80130,
        80135,
        80139,
        80140,
        80143,
        80144,
        80145,
        80150,
        80155,
        80159,
        80160,
        80170,
        80176,
        80177,
        80178,
        80179,
        80180,
        80184,
        80189,
        80190,
        80194,
        80197,
        80199,
        80200,
        80210,
        80220,
        80225,
        80227,
        80228,
        80230,
        80240,
        80246,
        80247,
        80248,
        80249,
        80250,
        80260,
        80270,
        80279,
        80280,
        80290,
        80294,
        80295,
        80296,
        80297,
        80298,
        80299,
        80300,
        80301,
        80308,
        80400,
        80402,
        80403,
        80405,
        80408,
        80409
    ],
    //"SK Express Boutique - 3629": [
       //80060,
       //80070,
       //80090,
       //80040,
       //80065,
       //80020,
       //80030,
       //99999
    //],// SK Express Boutique - 3629
    //"Hermosillo - 167": [
       //83130,
    //],// Monterrey 466
    // "Monterrey - 466": [
    //     66410,
    //     66436,
    //     66437,
    //     66440,
    //     66444,
    //     66445,
    //     66446,
    //     66447,
    //     66448,
    //     66449,
    //     66468,
    //     66470,
    //     66473,
    //     66474,
    //     66477,
    //     66478,
    //     66479,
    //     66490,
    //     66492,
    //     66494,
    //     66495,
    //     66496,
    //     66499,
    //     66600,
    //     66603,
    //     66604,
    //     66605,
    //     66606,
    //     66610,
    //     66630,
    //     66632,
    //     66633,
    //     66634,
    //     66635,
    //     66636,
    //     66637,
    //     66640,
    //     66643,
    //     66644,
    //     66645,
    //     66646,
    //     66647,
    //     66648,
    //     66649,
    //     67110,
    //     67112,
    //     67113,
    //     67115,
    //     67118,
    //     67119,
    //     67120,
    //     67123,
    //     67124,
    //     67125,
    //     67128,
    //     67129,
    //     67130,
    //     67134,
    //     67140,
    //     67144,
    //     67150,
    //     67154,
    //     67155,
    //     67160,
    //     67163,
    //     67164,
    //     67165,
    //     67166,
    //     67167,
    //     67168,
    //     67169,
    //     67170,
    //     67175,
    //     67176,
    //     67177,
    //     67180,
    //     67182,
    //     67183,
    //     67184,
    //     67185,
    //     67186,
    //     67188,
    //     67190,
    //     67192,
    //     67193,
    //     67194,
    //     67195,
    //     67196,
    //     67197,
    //     67198,
    //     67199,
    //     67200,
    //     67202,
    //     67203,
    //     67204,
    //     67205,
    //     67257,
    //     67280
    // ], // Monterrey 900
    // "Monterrey - 900": [
    //     64000,
    //     64100,
    //     64102,
    //     64103,
    //     64104,
    //     64105,
    //     64106,
    //     64108,
    //     64109,
    //     64116,
    //     64117,
    //     64118,
    //     64119,
    //     64120,
    //     64130,
    //     64140,
    //     64145,
    //     64148,
    //     64150,
    //     64157,
    //     64158,
    //     64159,
    //     64160,
    //     64165,
    //     64167,
    //     64168,
    //     64170,
    //     64178,
    //     64180,
    //     64190,
    //     64200,
    //     64204,
    //     64205,
    //     64206,
    //     64209,
    //     64210,
    //     64215,
    //     64217,
    //     64219,
    //     64225,
    //     64226,
    //     64227,
    //     64228,
    //     64229,
    //     64230,
    //     64233,
    //     64234,
    //     64235,
    //     64237,
    //     64240,
    //     64244,
    //     64245,
    //     64246,
    //     64247,
    //     64248,
    //     64249,
    //     64250,
    //     64259,
    //     64260,
    //     64264,
    //     64265,
    //     64268,
    //     64269,
    //     64280,
    //     64290,
    //     64299,
    //     64300,
    //     64310,
    //     64320,
    //     64330,
    //     64339,
    //     64340,
    //     64344,
    //     64346,
    //     64347,
    //     64348,
    //     64349,
    //     64350,
    //     64360,
    //     64366,
    //     64367,
    //     64368,
    //     64370,
    //     64380,
    //     64390,
    //     64410,
    //     64420,
    //     64440,
    //     64449,
    //     64450,
    //     64460,
    //     64470,
    //     64480,
    //     64488,
    //     64489,
    //     64500,
    //     64508,
    //     64510,
    //     64520,
    //     64530,
    //     64550,
    //     64570,
    //     64580,
    //     64600,
    //     64610,
    //     64613,
    //     64618,
    //     64619,
    //     64620,
    //     64638,
    //     64639,
    //     66024,
    //     66050,
    //     66055,
    //     66056,
    //     66058,
    //     66062,
    //     66064,
    //     66065,
    //     66068,
    //     66070,
    //     66072,
    //     66073,
    //     66400,
    //     66420,
    //     66428,
    //     66450,
    //     66455,
    //     66456,
    //     66457,
    //     66460,
    //     66465,
    //     66467,
    //     66480,
    //     66482,
    //     66484
    // ], // Jalisco 468
}

if (localStorage.getItem('postalCode')) {
    localStorage.setItem('postalCode', '80000')
}

if (localStorage.getItem('warehouse')) {
    localStorage.setItem('warehouse', 'Tienda en línea Culiacán - 4106')
}


const overlay = document.querySelector(".popUp-overlay");
const form = document.querySelector('#cpForm');
const cp = document.querySelector("#cp-code");
const openBtn = document.querySelector(".popUp-open");
const openBtnText = document.querySelector(".popUp-open-text");
//const closeBtn = document.querySelector(".popUp-close");
const currentStore = document.querySelector("#current-store-cp");
const currentStoreContainer = document.querySelector('.current-store-container');
//const failMsg = document.querySelector('.no-service-popup');

const sucursal = document.getElementById('cpForm1');

function irCP(){
  sucursal.style.display = 'none';
  form.style.display = 'inline';
}

function irSucursal(){
  sucursal.style.display = 'inline';
  form.style.display = 'none';
}

function handlePopUp() {
    if (overlay.classList.contains('hidden-pop')) {
        overlay.classList.remove('hidden-pop');
        overlay.classList.add('open-pop');
    } else {
        overlay.classList.remove('open-pop');
        overlay.classList.add('hidden-pop');
    }
}

window.addEventListener("load", () => {
    if (localStorage.getItem('availability') === null ) {
        overlay.classList.remove("hidden-pop");
    } else if (localStorage.getItem('availability') === "true") {
        currentStoreContainer.classList.remove('hidden-pop');
    }

    if (localStorage.getItem('postalCode')) {
        cp.value = localStorage.getItem('postalCode');
    }

    switch(localStorage.getItem('warehouse')) {
        //case 'Monterrey - 3637':
          //  currentStore.innerText = "Monterrey, Vasconcelos";
            //break;
        case 'Tienda en línea Culiacán - 4106':
            currentStore.innerText = "Tienda en línea Culiacán";
            break;
        //case 'SK Express Boutique - 3629':
            //currentStore.innerText = "SK Express Boutique";
            //break;
        //case 'Hermosillo - 167':
          //  currentStore.innerText = "Hermosillo";
            //break;
        //case 'Monterrey - 466':
          //  currentStore.innerText = "Monterrey, San Miguel";
            //break;
        //case 'Monterrey - 900':
          //  currentStore.innerText = "Monterrey, Lincoln";
            //break;
    }
})

/*closeBtn.addEventListener('click', () => {
    handlePopUp()
    if (localStorage.getItem('availability') === null) {
        localStorage.setItem('availability', false)
    }
    
});*/
openBtn.addEventListener('click', handlePopUp);
currentStore.addEventListener('click', handlePopUp);

form.addEventListener('submit', async (e) => {
    e.preventDefault();
    let clickedButton = event.submitter; // Get the button that was clicked
    localStorage.setItem('warehouse', clickedButton.value);
    localStorage.setItem("postalCode", warehouses[clickedButton.value][0]);
    localStorage.setItem('availability', true);
    //for (let warehouse in warehouses) {
        // console.log(warehouses[warehouse])
        // console.log(cp.value)
        //if(warehouses[warehouse].includes(Number(cp.value))) {
            //localStorage.setItem("postalCode", cp.value);
            //localStorage.setItem("warehouse", warehouse);
            //localStorage.setItem('availability', true);
            //failMsg.classList.add('hidden-pop');

            switch(clickedButton.value) {
                //case 'Monterrey - 3637':
                  //  localStorage.setItem("warehouseCode", '3637');
                    //break;
                case 'Tienda en línea Culiacán - 4106':
                    localStorage.setItem("warehouseCode", '4106');
                    break;
                //case 'SK Express Boutique - 3629':
                    //localStorage.setItem("warehouseCode", '3629');
                  //break;
                //case 'Hermosillo - 167':
                  //  localStorage.setItem("warehouseCode", '167');
                  //break;
                //case 'Monterrey - 466':
                   // localStorage.setItem("warehouseCode", '466');
                   // break;
                //case 'Monterrey - 900':
                    //localStorage.setItem("warehouseCode", '900');
                   // break;
            }
            await fetch(window.Shopify.routes.root + "cart/clear.js", {
                method: 'POST',
                headers: {
                    "Content-Type": "application/json"
                }
            })

            window.location.reload();
            //break;
        //} else {
            //localStorage.setItem("postalCode", cp.value);
            //localStorage.removeItem("warehouse");
            //localStorage.setItem('availability', false);
            //currentStoreContainer.classList.add('hidden-pop');
            //failMsg.classList.remove('hidden-pop');
            //setTimeout(() => window.location.reload(), 4000);
        //}
    //}
    
    return false;
})
